"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ActionsTricolon = require("../ActionsTricolon");

var _Container = require("./Container");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
var ArrowStyled = _styledComponents["default"].div.withConfig({
  displayName: "Arrow__ArrowStyled",
  componentId: "yauoog-0"
})(["display:flex;flex-direction:row;align-items:flex-end;line-height:0;font-size:14px;color:", ";"], function (_ref) {
  var color = _ref.color;
  return color;
});

var ArrowLine = _styledComponents["default"].div.withConfig({
  displayName: "Arrow__ArrowLine",
  componentId: "yauoog-1"
})(["width:100% !important;height:0px;border:", " 1px dotted;"], function (_ref2) {
  var color = _ref2.color;
  return color;
});

var ArrowTitle = _styledComponents["default"].div.withConfig({
  displayName: "Arrow__ArrowTitle",
  componentId: "yauoog-2"
})(["color:#ff5a60;font-size:12px;width:100%;display:flex;justify-content:center;color:", ";"], function (_ref3) {
  var color = _ref3.color;
  return color;
});

var Arrow = function Arrow(props) {
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, props, /*#__PURE__*/_react["default"].createElement(ArrowTitle, props, props.actions && props.actions.length > 0 ? /*#__PURE__*/_react["default"].createElement(_ActionsTricolon.ActionsTricolon, _extends({
    tooltipPlacement: "left"
  }, props)) : null, props.caption), /*#__PURE__*/_react["default"].createElement(ArrowStyled, props, "\u2523 ", /*#__PURE__*/_react["default"].createElement(ArrowLine, props), "\u25B6"));
}; // Arrow.propTypes = {
//   width: PropTypes.string,
//   caption: PropTypes.string || PropTypes.element,
//   color: PropTypes.string,
//   visible: PropTypes.bool
// }


exports.Arrow = Arrow;
Arrow.defaultProps = {
  width: '0',
  caption: '',
  color: 'red',
  visible: true
};